import * as yup from 'yup';

const validationSchema = (intl) =>
  yup.object({
    name: yup
      .string('')
      .min(3, intl.formatMessage({ id: 'validation.name.min_length' }, { length: 3 }))
      .required(intl.formatMessage({ id: 'validation.required' })),
    street: yup
      .string('')
      .min(3, intl.formatMessage({ id: 'validation.street.min_length' }, { length: 3 }))
      .required(intl.formatMessage({ id: 'validation.required' })),
    zipCode: yup
      .string('')
      .min(5, intl.formatMessage({ id: 'validation.zip_code.min_length' }, { length: 5 }))
      .required(intl.formatMessage({ id: 'validation.required' })),
    city: yup
      .string('')
      .min(3, intl.formatMessage({ id: 'validation.city.min_length' }, { length: 3 }))
      .required(intl.formatMessage({ id: 'validation.required' })),
  });

export default validationSchema;
